/**
 * Text direction for a locale (locale/RTL audit, 2026-09-26).
 *
 * The single answer to "is this UI right-to-left?", shared by the i18n
 * provider (which stamps `dir` on <html> and feeds Radix's DirectionProvider)
 * and by layout primitives that need to flip (the sidebar's side, directional
 * icons). Base-language match, so 'ar-AE' and 'ar' both read right-to-left.
 */
export const RTL_BASE_LANGUAGES: ReadonlySet<string> = new Set(['ar', 'he', 'fa', 'ur', 'ps', 'dv'])

export type TextDirection = 'ltr' | 'rtl'

export function directionFor(locale: string | null | undefined): TextDirection {
  if (!locale) return 'ltr'
  const base = locale.trim().toLowerCase().split(/[-_]/)[0]
  return RTL_BASE_LANGUAGES.has(base) ? 'rtl' : 'ltr'
}
